import React from 'react';

const CookiesPolicy = () => {
  return (
    <div className="min-h-screen pt-20 pb-8 px-4 md:px-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-2xl md:text-4xl font-bold text-white mb-4">Cookies Policy</h1>
          <p className="text-gray-400 text-sm md:text-base">Informazioni sull'utilizzo dei cookies</p>
        </div>

        <div className="bg-black rounded-xl p-6 md:p-8 space-y-6 text-gray-300">
          <section>
            <h2 className="text-xl font-semibold text-white mb-4">1. Cosa sono i Cookies</h2>
            <p className="text-sm md:text-base leading-relaxed">
              I cookies sono piccoli file di testo che vengono memorizzati sul dispositivo dell'utente durante la navigazione 
              per migliorare l'esperienza di utilizzo del sito web.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">2. Tipologie di Cookies Utilizzati</h2>
            <div className="space-y-3 text-sm md:text-base leading-relaxed">
              <p><strong className="text-white">Cookies Tecnici:</strong> Necessari per il funzionamento del sito e dei servizi richiesti dall'utente.</p>
              <p><strong className="text-white">Cookies di Preferenze:</strong> Per memorizzare le scelte dell'utente e personalizzare l'esperienza.</p>
              <p><strong className="text-white">Cookies Analitici:</strong> Per analizzare l'utilizzo del sito e migliorare i servizi offerti.</p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">3. Gestione dei Cookies</h2>
            <p className="text-sm md:text-base leading-relaxed">
              È possibile gestire le preferenze sui cookies attraverso le impostazioni del browser. 
              La disabilitazione di alcuni cookies potrebbe limitare alcune funzionalità del sito.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-4">4. Cookies di Terze Parti</h2>
            <p className="text-sm md:text-base leading-relaxed">
              Il sito potrebbe utilizzare cookies di terze parti per servizi di analisi e funzionalità social. 
              Questi cookies sono soggetti alle rispettive privacy policy dei fornitori.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiesPolicy;
